// extracted by mini-css-extract-plugin
module.exports = {"burgerMenuButton":"styles_burgerMenuButton__2V2o2","activeMobileMenu":"styles_activeMobileMenu__3WwjT"};